import NotFound from "pages/common/notFound";
import React from "react";
import { Route, Routes } from "react-router-dom";
import Profile from "./profileMobile";
import CurrentSchedules from "./CurrentSchedules";
import PastSchedules from "./PastSchedules";
import FavoriteSchedules from "./FavoriteSchedules";
import AddressMobile from "pages/address/mobile/addressMobile";

/**
 * 파일명: Mypage.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: 마이페이지 router
 */
function Mypage() {
  return (
    <Routes>
      <Route path="/schedule" element={<CurrentSchedules />} />
      <Route path="/past" element={<PastSchedules />} />
      <Route path="/favorite" element={<FavoriteSchedules />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/address" element={<AddressMobile />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Mypage;
